import styled, { css } from 'styled-components';

import { CtaButton } from '@getgrover/ui';

const Login = styled.button`
    ${({theme}) => css(theme.typography.SmallCapsHeadline)};
    color: ${({ theme }) => theme.colors.Foreground};
    cursor: pointer;
    &:hover {
        opacity: 0.5;
    }
    span {
        text-transform: uppercase;
        cursor: pointer;
    }
    margin-left: auto;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        span {
            font-size: 12px;
        }
    `};
    ${({ theme, isTransparent }) => isTransparent && `color: ${theme.colors.Background};`};
`;

const SignUp = styled(CtaButton)`
    display: inline-block;
    margin-left: ${({ theme }) => theme.spacers.L};
    line-height: 32px;
`;

export { Login, SignUp };
